import React from "react";

import { sendLogoutForm } from "@/api/auth";
import { LockIcon } from "@/assets/icons";
import { Button } from "@/components/ui/Button";
import { useAuthContext } from "@/context/auth";
import { isTechnicalPermission } from "@/features/utils";

export const NoPermissionsView = () => {
  const { user } = useAuthContext();
  const authorities = user?.authorities ?? [];
  // Bare technical roles (`auth:admin`) and what `auth:support` / `auth:superadmin` imply are not
  // permissions a role grants, so they say nothing about a UserManager that is off
  const holdsImpliedPermissions =
    authorities.includes("auth:support") || authorities.includes("auth:superadmin");
  const hasDormantPermissions =
    !holdsImpliedPermissions &&
    !authorities.includes("auth:user") &&
    authorities.some(
      (authority) => authority.startsWith("auth:") && !isTechnicalPermission(authority),
    );

  return (
    <div className="flex h-screen w-full items-center justify-center bg-muted">
      <div className="flex flex-col items-center justify-center gap-3 rounded-lg bg-background px-8 py-6 shadow-xs">
        <LockIcon className="h-20 w-auto text-muted-foreground" />
        <div className="max-w-[500px] text-center">
          <h3>Access restricted</h3>
          {hasDormantPermissions ? (
            <p>
              You have UserManager permissions assigned, but access to the product is not enabled.
              Please ask your administrator to enable UserManager, or switch account.
            </p>
          ) : (
            <p>
              You don't have permission to view this page. If this is not desired behavior please
              contact SkillPanel for further assistance, or switch account.
            </p>
          )}
        </div>
        <Button variant="outline" onClick={() => sendLogoutForm()}>
          Log out
        </Button>
      </div>
    </div>
  );
};
